
import iconOne from 'images/icon-1.png';
import iconTwo from 'images/icon-2.png';
import iconThree from 'images/icon-3.png';
import iconFour from 'images/icon-4.png';
import * as S from './styles';

function SectionFive() {
  return (
    <S.Wrapper>
      <S.Container>
        <ul>
          <li>
            <div>
              <img src={iconOne} alt="" />
              <h4>Newbies</h4>
            </div>
            <p>You can learn without barriers & essentially cheat your way up to the top</p>
          </li>
          <li>
            <div>
              <img src={iconTwo} alt="" />
              <h4>Pros</h4>
            </div>
            <p>Scale your campaigns 10x with help from super-affiliates</p>
          </li>
          <li>
            <div>
              <img src={iconFour} alt="" />
              <h4>Veterans</h4>
            </div>
            <p>You can expand your business & work with others on your level</p>
          </li>
          <li>
            <div>
              <img src={iconThree} alt="" />
              
              <h4>Companies</h4>
            </div>
            <p>Super-affiliates are just a quick post away</p>
          </li>
        </ul>
      </S.Container>
    </S.Wrapper>
  );
}

export default SectionFive;
